module.exports = __webpack_public_path__ + "img/jurassic-world-alive.6d4e0fe5.png";